<template>
  <div class="catalog_module">
    <div class="search flex">
      <span class="tit">字典管理</span>
<!--      <div class="flex">-->
<!--        <el-input suffix-icon="el-icon-search" class="addART" v-model="searchKey" size="mini" placeholder="输入字典名称搜索"/>-->
<!--      </div>-->
    </div>
    <el-container>
      <el-aside width="220px" style="overflow-y: scroll;
    height: calc(100vh - 240px);">
        <ul class="aside-ul">
          <li v-for="item in dictList"
              :key="item.id"
              class="aside-li"
              @click="changeDict(item)"
              :active="curDict.id==item.id?'1':'0'">
            <span>{{ item.dictName }}</span>
          </li>
        </ul>
      </el-aside>
      <el-main>
        <div class="dict-info flex">
          <div>
            <p>
              <span class="title"><label>字典名称:</label>{{ curDict.dictName }}</span>
              <span class="title"><label>字典代码:</label>{{ curDict.dictCode }}</span>
            </p>
            <p><label>描述:</label>{{ curDict.dictDesc ? curDict.dictDesc : '-' }}</p>
            <p><label>备注:</label>{{ curDict.remark ? curDict.remark : '-' }}</p>
          </div>

          <div class="dict-operate">
            <el-button type="primary" size="small" style="color: #ffffff" class="addBtn" @click="editItem(0)">
              新增子项
            </el-button>
          </div>
        </div>
        <el-table :data="dictItemList"
                  :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                  height="calc(100vh - 400px)" class="record-table"
                  max-height="calc(100vh - 400px)">
          <el-table-column type="expand" align="center">
            <template slot-scope="props">
              <p><label class="title">icon:</label>{{ props.row.itemIcon ? props.row.itemIcon : '-' }}</p>
              <p><label class="title">描述:</label>{{ props.row.itemDesc ? props.row.itemDesc : '-' }}</p>
              <p><label class="title">备注:</label>{{ props.row.remark ? props.row.remark : '-' }}</p>
            </template>
          </el-table-column>
          <el-table-column label="排序" property="sort" align="center"></el-table-column>
          <el-table-column label="子项名称" show-overflow-tooltip prop="itemName"  align="center"></el-table-column>
          <el-table-column label="代码" prop="itemCode"  align="center"></el-table-column>
          <el-table-column label="状态" width="100"  align="center">
            <el-button slot-scope="scope" :state="scope.row.status" @click="changeStatus(scope.row)" type="text"
                       size="small">{{ scope.row.status == 0 ? '禁用' : '启用' }}
            </el-button>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <template v-if="scope.row.itemType==1">
                <el-button @click="editItem(scope.row)" type="text" size="small">
                  编辑
                </el-button>
                <el-popconfirm
                    confirm-button-text='好的'
                    cancel-button-text='不用了'
                    icon="el-icon-info"
                    icon-color="red"
                    @confirm="del(scope.row.id)"
                    title="确定删除吗？">
                  <el-button slot="reference" class="btn" type="text" size="small">删除</el-button>
                </el-popconfirm>
              </template>
              <span v-else class="disabled-tips">系统字段无法修改</span>
              <el-button v-if="scope.row.haveSubItem===1" type="text" size="small" @click="editSubItem()">子项管理</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>

    <el-drawer
        :visible.sync="editDialog.visible"
        :wrapperClosable="false" :show-close="false"
        :title="(editDialog.mode==='add'?'新增':'编辑')+'子项'"
        size="700px" class="drawerCommon">
      <el-form :model="curItem" label-suffix="：" label-width="90px" class="maxHeight">
        <el-form-item label="子项名称">
          <el-input v-model="curItem.itemName"></el-input>
        </el-form-item>
        <el-form-item label="代码">
          <el-input v-model="curItem.itemCode"></el-input>
        </el-form-item>
        <el-form-item label="icon">
          <el-upload
              class="avatar-uploader"
              :action="iconUploadUrl"
              :show-file-list="false"
              name="uploadFile"
              :on-success="handleIconSuccess">
            <img v-if="curItem.itemIcon" :src="curItem.itemIcon" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" rows="4" v-model="curItem.itemDesc"></el-input>
        </el-form-item>
        <el-form-item label="排序" v-if="editDialog.mode!=='add'">
          <el-input-number v-model="curItem.sort" :step="1" step-strictly></el-input-number>
        </el-form-item>
<!--        <el-form-item label="子项" v-if="curItem.itemType === 1">-->
<!--          <el-radio-group v-model="curItem.haveSubItem">-->
<!--            <el-radio :label="0">无</el-radio>-->
<!--            <el-radio :label="1">有</el-radio>-->
<!--          </el-radio-group>-->
<!--        </el-form-item>-->
        <el-form-item label="备注">
          <el-input type="textarea" rows="4" v-model="curItem.remark"></el-input>
        </el-form-item>
      </el-form>

      <div class="footer">
        <el-button size="small" type="primary" @click="saveItem">保存</el-button>
        <el-button size="small" @click="editDialog.visible=false">取消</el-button>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import base from "../../../api/common";

export default {
  name: "catalogList",
  data() {
    return {
      searchKey: '',
      curDict: {
        id: 2,
        dictCode: '',
        dictDesc: '',
        dictName: '',
        dictType: 1,
        remark: '',
      },

      dictList: [],
      dictItemList: [],
      curItem: {
        id: '',
        itemCode: '',
        itemName: '',
        itemIcon: '',
        itemDesc: '',
        remark: '',
        sort: 0,
      },
      editDialog: {
        visible: false,
        mode: 'add',
      },
      iconUploadUrl: base.uploadUrl + 'dict',
    }
  },
  mounted() {
    let that = this;
    that.$ajax.get(base.api.dict.edit.list).then(res => {
      if (res.data.status === 'success') {
        that.dictList = res.data.list;
        if (res.data.list.length > 0) {
          that.changeDict(res.data.list[0]);
        }
      }
    })
  },
  methods: {
    changeDict(item) {
      if (item && item.id) {
        let that = this;
        that.curDict = item;
        that.$ajax.get(base.api.dict.edit.item.list.replace("{catalogId}", item.id)).then(res => {
          if (res.data.status === 'success') {
            that.dictItemList = res.data.list;
          }
        });
      }
    },
    changeStatus(item) {
      if (item && item.id) {
        let that = this;
        let targetStatus = (item.status + 1) % 2;
        that.$messageBox.confirm('确定要' + (targetStatus == 1 ? '启用' : '禁用') + '吗?', '状态确认', {type: 'warning'}).then(_ => {
          that.$ajax.post(base.api.dict.item.updateStatus.replace("{id}", item.id).replace("{status}", targetStatus)).then(res => {
            if (res.data.status === 'success') {
              that.$message.success('操作成功');
              item.status = targetStatus;
            } else {
              that.$message.error(res.data.message);
            }
          }).catch(err => {
            console.error(err);
            that.$message.error("操作失败！");
          });
        }).catch();
      }
    },
    editItem(item) {
      let that = this;
      if (item.id) { // 编辑
        that.editDialog.mode = 'edit';
        that.curItem.id = item.id;
        that.curItem.itemCode = item.itemCode;
        that.curItem.itemName = item.itemName;
        that.curItem.itemIcon = item.itemIcon;
        that.curItem.itemDesc = item.itemDesc;
        that.curItem.itemType = item.itemType;
        that.curItem.remark = item.remark;
        that.curItem.sort = item.sort;
        that.curItem.catalogId = that.curDict.id;
      } else { // 新增
        that.editDialog.mode = 'add';
        that.curItem.id = '';
        that.curItem.itemCode = '';
        that.curItem.itemName = '';
        that.curItem.itemIcon = '';
        that.curItem.itemDesc = '';
        that.curItem.remark = '';
        that.curItem.sort = 0;
        that.curItem.catalogId = that.curDict.id;
      }
      that.editDialog.visible = true;
    },
    handleIconSuccess(res, file) {
      let that = this;
      if (res.status === 'success') {
        that.curItem.itemIcon = res.message;
      }
    },
    saveItem() {
      let that = this;
      let url = base.api.dict.item.add.replace("{catalogId}", that.curDict.id);
      if (that.editDialog.mode === 'edit') {
        url = base.api.dict.item.edit;
      }
      that.$ajax.post(url, that.curItem).then(res => {
        if (res.data.status === 'success') {
          that.$message.success('保存成功');
          that.changeDict(that.curDict);
          that.editDialog.visible = false;
        } else {
          that.$message.error(res.data.message);
        }
      }).catch(err => {
        console.error(err);
        that.$message.error("操作失败");
      });
    },
    //管理三级字典表
    editSubItem() {
      this.$router.push({
        name: 'itemList',
        query: {
          id: this.curDict.id,
          name: this.curDict.dictName,
        }
      })
    },
    del(id) {
      let that = this;
      this.$ajax.get(base.api.dict.edit.item.delete.replace("{id}", id)).then((res) => {
        if (res.data.status === 'success') {
          that.$message.success('操作成功')
          that.changeDict(that.curDict);
        } else {
          that.$message.error(res.data.message)
        }
      }).catch((err) => {
        console.error(err)
        that.$message.error('操作失败')
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

.catalog_module {
  ::v-deep .el-main {
    height: calc(100vh - 240px);
    min-height: 480px;
  }
}

.aside-ul {
  padding: 0;

  li.aside-li {
    height: 28px;
    line-height: 28px;
    margin: 10px 0;
    padding-left: 40px;
    text-align: left;
    font-size: 14px;
    color: rgb(42, 45, 46);
    cursor: pointer;
  }

  li.aside-li[active='1'] {
    font-weight: 700;
    color: rgb(86, 124, 255);
  }
}

.dict-info {
  padding: 10px 20px;
  position: relative;
  justify-content: space-between;
  align-items: normal;
  font-size: 14px;

  p {
    line-height: 20px;
    margin: 10px 0;

    color: #5e6d82;

    span.title {
      display: inline-block;
      width: 300px;
    }
  }

  ::v-deep label {
    font-size: 16px;
    font-weight: 700;
    color: #1f2f3d;
    margin: 10px 20px 10px 0;
  }

  /* ::v-deep span, p {

   }*/

  /*.dict-operate {
    position: absolute;
    right: 40px;
    top: 20px;

    button {
      padding: 0;
      width: 86px;
      height: 32px;
    }
  }*/
}

button[state='0'] {
  color: #f56c6c
}

button[state='1'] {
  color: #67c23a
}

span.disabled-tips {
  font-size: 12px;
  color: #f56c6c;
  cursor: not-allowed;
}

label.title {
  margin-right: 10px;
  font-weight: 700
}
</style>
